/* Lack Depot — Quick add-to-cart button on product cards
   Adds an "In den Warenkorb" gold pill to each product card on collection/search pages.
   Click → fetches /products/HANDLE.js, picks first available variant, POSTs to /cart/add.js,
   updates the cart count bubble. */

(function () {
  'use strict';

  const isEn = document.documentElement.lang && document.documentElement.lang.toLowerCase().startsWith('en');
  const LABEL = isEn ? 'Add to cart' : 'In den Warenkorb';
  const LABEL_DONE = isEn ? 'Added ✓' : 'Hinzugefügt ✓';
  const LABEL_FAIL = isEn ? 'Try again' : 'Fehler — erneut';

  function ensureStyles() {
    if (document.getElementById('ldqa-styles')) return;
    const css = document.createElement('style');
    css.id = 'ldqa-styles';
    css.textContent = `
      .ldqa-btn {
        position: absolute;
        right: 12px;
        bottom: 12px;
        z-index: 6;
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 9px 16px;
        background: linear-gradient(135deg, #d4af6e 0%, #b8860b 100%);
        color: #0a1428;
        border: none;
        border-radius: 100px;
        font-size: 11px;
        font-weight: 800;
        letter-spacing: 0.14em;
        text-transform: uppercase;
        cursor: pointer;
        /* Always visible — Ali asked for no hover reveal (2026-07-22). Button
           sits on every card regardless of viewport or pointer type. */
        opacity: 1;
        transform: none;
        transition: box-shadow 0.2s ease;
        box-shadow: 0 4px 14px rgba(184,134,11,0.25);
        font-family: inherit;
      }
      .ldqa-btn:hover { box-shadow: 0 6px 18px rgba(184,134,11,0.4); }
      .ldqa-btn:disabled { opacity: 0.7 !important; cursor: wait; }
      .ldqa-btn svg { width: 12px; height: 12px; }
      .card-wrapper, .ldff__card { position: relative; }

      /* Collection cards — center the pill horizontally at the bottom of the
         card. Ali's ask 2026-07-22: "add it to the middle" for collections. */
      .card-wrapper .ldqa-btn {
        left: 50%;
        right: auto;
        transform: translateX(-50%);
      }

      /* Homepage .ldff__card cards — anchor the pill at the top-right of the
         image area (not the bottom) so it doesn't overlap the product title
         and price text that sits at the bottom of the card. Also shrink it. */
      .ldff__card .ldqa-btn {
        top: 10px;
        bottom: auto;
        right: 10px;
        left: auto;
        transform: none;
        padding: 5px 10px;
        font-size: 9px;
        letter-spacing: 0.08em;
        gap: 4px;
      }
      .ldff__card .ldqa-btn svg { width: 10px; height: 10px; }
      @media (max-width: 768px) {
        .ldqa-btn {
          padding: 8px 14px;
          font-size: 10px;
          right: 8px;
          bottom: 8px;
          letter-spacing: 0.1em;
        }
      }
      @media (max-width: 480px) {
        .ldqa-btn {
          /* Full-width pill at bottom of card on small phones */
          left: 8px;
          right: 8px;
          bottom: 8px;
          justify-content: center;
          padding: 10px 12px;
          font-size: 11px;
        }
      }

      /* Toast confirmation */
      .ldqa-toast {
        position: fixed;
        right: 24px;
        bottom: 24px;
        z-index: 99999;
        background: #0a1428;
        color: #fff;
        border-left: 3px solid #c9a55c;
        padding: 14px 22px;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 600;
        letter-spacing: 0.04em;
        box-shadow: 0 12px 32px rgba(0,0,0,0.25);
        opacity: 0;
        transform: translateY(8px);
        transition: opacity 0.25s ease, transform 0.25s ease;
        max-width: 320px;
      }
      .ldqa-toast.open { opacity: 1; transform: translateY(0); }
      .ldqa-toast strong { color: #c9a55c; font-weight: 800; letter-spacing: 0.08em; }
    `;
    document.head.appendChild(css);
  }

  function showToast(msg) {
    let toast = document.querySelector('.ldqa-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'ldqa-toast';
      document.body.appendChild(toast);
    }
    toast.innerHTML = msg;
    requestAnimationFrame(() => toast.classList.add('open'));
    clearTimeout(toast._timer);
    toast._timer = setTimeout(() => toast.classList.remove('open'), 2400);
  }

  function bumpCartCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(r => r.json())
      .then(cart => {
        document.querySelectorAll('.cart-count-bubble, [data-cart-count]').forEach(el => {
          const span = el.querySelector('span') || el;
          span.textContent = cart.item_count;
        });
      })
      .catch(() => {});
  }

  function addByHandle(handle, btn) {
    btn.disabled = true;
    const originalLabel = btn.dataset.label;
    btn.querySelector('.ldqa-btn__text').textContent = isEn ? 'Adding…' : 'Hinzufügen…';

    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(r => r.json())
      .then(product => {
        const variant = (product.variants || []).find(v => v.available) || product.variants[0];
        if (!variant) throw new Error('No variant');
        // Ask Shopify to render the cart-drawer + cart-icon-bubble sections
        // alongside the add response. Without this, the drawer DOM stays stale
        // (the cart cookie updates, the count bubble updates, but the drawer
        // still shows the OLD cart — clicking it then shows missing items and
        // breaks the View Cart button). With sections, we can pipe the fresh
        // HTML straight into cart-drawer.renderContents().
        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [{ id: variant.id, quantity: 1 }],
            sections: 'cart-drawer,cart-icon-bubble',
            sections_url: location.pathname
          })
        }).then(r => {
          if (!r.ok) return r.json().then(j => Promise.reject(j));
          return r.json();
        }).then(cartAddResponse => ({ product: product, cart: cartAddResponse }));
      })
      .then(({ product, cart }) => {
        btn.querySelector('.ldqa-btn__text').textContent = LABEL_DONE;
        showToast(`<strong>${isEn ? 'Added' : 'Hinzugefügt'}:</strong><br>${product.title}`);

        // Hand the rendered sections to the theme's cart-drawer custom element.
        // renderContents() replaces the drawer DOM AND opens the drawer at the
        // end, so the drawer slides in already showing the new item.
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function' && cart && cart.sections) {
          try {
            drawer.renderContents(cart);
          } catch (e) {
            console.warn('cart-drawer renderContents failed, falling back to count bump', e);
            bumpCartCount();
          }
        } else {
          bumpCartCount();
        }

        setTimeout(() => {
          btn.disabled = false;
          btn.querySelector('.ldqa-btn__text').textContent = originalLabel;
        }, 1800);
      })
      .catch(err => {
        console.warn('Quick-add failed', err);
        btn.querySelector('.ldqa-btn__text').textContent = LABEL_FAIL;
        showToast(`<strong>${isEn ? 'Sorry' : 'Hoppla'}</strong><br>${(err && err.description) || (isEn ? 'Could not add to cart.' : 'Konnte nicht hinzugefügt werden.')}`);
        setTimeout(() => {
          btn.disabled = false;
          btn.querySelector('.ldqa-btn__text').textContent = originalLabel;
        }, 2200);
      });
  }

  function getHandleFromCard(card) {
    // On collection cards the anchor is INSIDE the card wrapper. On the
    // homepage's `.ldff__card`, the card element IS an <a> — check both.
    var link = null;
    if (card.tagName === 'A' && (card.getAttribute('href') || '').indexOf('/products/') !== -1) {
      link = card;
    } else {
      link = card.querySelector('a[href*="/products/"]');
    }
    if (!link) return null;
    var m = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function attachToCard(card) {
    if (card.dataset.ldqa === '1') return;
    const handle = getHandleFromCard(card);
    if (!handle) return;
    card.dataset.ldqa = '1';

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ldqa-btn';
    btn.dataset.label = LABEL;
    btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M12 5v14M5 12h14" stroke-linecap="round"/></svg><span class="ldqa-btn__text">' + LABEL + '</span>';
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      addByHandle(handle, btn);
    });
    card.appendChild(btn);
  }

  function scan() {
    document.querySelectorAll('.card-wrapper, .ldff__card').forEach(attachToCard);
  }

  function init() {
    ensureStyles();
    scan();
    // Re-scan on AJAX-loaded content
    const observer = new MutationObserver((mutations) => {
      let needs = false;
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType === 1 && (node.matches?.('.card-wrapper, .ldff__card') || node.querySelector?.('.card-wrapper, .ldff__card'))) {
            needs = true; break;
          }
        }
        if (needs) break;
      }
      if (needs) scan();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
